import { actions } from 'forms/rrf';
import { toast } from 'react-toastify';
import qs from 'qs';
import irelandApi from '../irelandApi';
import store, { history } from '../store';
import ToastMessage from '../components/common/toast-message';

export const getCategories = () => (dispatch) => {
  dispatch({type: 'GET_NEWS_CATEGORY_LIST_PENDING'});
  return irelandApi.get('/api/admin/news_categories')
    .then((response) => {
      dispatch({type: 'GET_NEWS_CATEGORY_LIST_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_NEWS_CATEGORY_LIST_REJECTED', payLoad: error.data});
    });
};

export const getCategory = id => (dispatch) => {
  dispatch({type: 'GET_NEWS_CATEGORY_PENDING'});
  return irelandApi.get(`/api/admin/news_categories/${id}`)
    .then((response) => {
      const {attributes} = response.data.data;
      const category = {
        name: attributes.name || ''
      };
      dispatch(actions.load('deep.admin_news.category', category));
      dispatch({type: 'GET_NEWS_CATEGORY_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_NEWS_CATEGORY_REJECTED', payLoad: error.data});
    });
};

export const deleteCategory = id => (dispatch) => {
  dispatch({type: 'DELETE_NEWS_CATEGORY_PENDING'});
  return irelandApi.delete(`/api/admin/news_categories/${id}`)
    .then(() => {
      toast.success(<ToastMessage
        iconStyle="success"
        message="News category has been deleted successfully"
      />);
      dispatch({type: 'DELETE_NEWS_CATEGORY_FULFILLED', payLoad: id});
    })
    .catch((error) => {
      toast.error(<ToastMessage
        iconStyle="error"
        message="An error occured during delete news category"
      />);
      dispatch({type: 'DELETE_NEWS_CATEGORY_REJECTED', payLoad: error.data});
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    });
};

export const saveCategory = payLoad => irelandApi.post('/api/admin/news_categories/', {news_category: payLoad})
  .then(() => {
    toast.success(<ToastMessage
      iconStyle="success"
      message="News category has been saved successfully"
    />);
    history.push('/admin/news/categories');
  })
  .catch((error) => {
    toast.error(<ToastMessage
      iconStyle="error"
      message="An error occurred during save news category"
    />);
    store.dispatch(actions.resetValidity('deep.admin_news.category'));
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });

export const updateCategory = (id, payLoad) => irelandApi.patch(`/api/admin/news_categories/${id}`, {news_category: payLoad})
  .then(() => {
    toast.success(<ToastMessage
      iconStyle="success"
      message="News category has been saved successfully"
    />);
    history.push('/admin/news/categories');
  })
  .catch((error) => {
    toast.error(<ToastMessage
      iconStyle="error"
      message="An error occurred during save news category"
    />);
    store.dispatch(actions.resetValidity('deep.admin_news.category'));
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });

export const getArticles = (query, dateFrom, dateTo, status, orderBy, order, page) => (dispatch) => {
  dispatch({type: 'GET_NEWS_ARTICLE_LIST_PENDING'});
  const q = {
    title: query,
    display_from_date: dateFrom,
    display_to_date: dateTo,
    status,
    order_by: orderBy,
    order
  };
  return irelandApi.get(`/api/admin/articles/?${qs.stringify({q}, {encodeValuesOnly: true})}&location=website&page=${page}`)
    .then((response) => {
      dispatch({type: 'GET_NEWS_ARTICLE_LIST_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_NEWS_ARTICLE_LIST_REJECTED', payLoad: error.data});
    });
};

export const getArticle = id => (dispatch) => {
  dispatch({type: 'GET_NEWS_ARTICLE_PENDING'});

  const suffix = id || 'new';

  return irelandApi.get(`/api/admin/articles/${suffix}`)
    .then((response) => {
      const collectPermissions = (permissions) => {
        const permissionIds = {};

        if (permissions) {
          permissions.forEach((item) => {
            item.children.forEach((perm) => {
              permissionIds[perm.id] = {
                name: perm.name,
                checked: perm.checked
              };
            });
          });
        }

        return permissionIds;
      };

      if (response.data.data) { // existing article
        const { attributes } = response.data.data;
        const permissionIds = collectPermissions(attributes.permissions);

        const createGroupList = groups =>
          groups.map(curr => ({
            value: curr
          }));

        const article = {
          title: attributes.title,
          title_text_colour: attributes['title-text-colour'],
          video_link: attributes['video-link'],
          game_link: attributes['game-link'],
          cataboom_id: attributes['cataboom-id'],
          external_url: attributes['external-url'],
          news_category_id: attributes['news-category-id'],
          status: attributes.status,
          display_from_date: attributes['display-from-date'],
          display_to_date: attributes['display-to-date'],
          display_location: attributes['display-location'],
          featured: attributes.featured.toString(),
          linked_article_ids: attributes['linked-articles'],
          permission_ids: permissionIds,
          group_ids: createGroupList(attributes['group-ids']),
          abm_codes: attributes['abm-codes'],
          mc_only_outlets: attributes['mc-only-outlets'],
          non_mc_only_outlets: attributes['non-mc-only-outlets'],
        };

        dispatch(actions.load('deep.admin_news.article', article));
      } else { // new article, set defaults
        const permissionIds = collectPermissions(response.data.meta.permissions);

        dispatch(actions.change('deep.admin_news.article.title_text_colour', 'Red'));
        dispatch(actions.change('deep.admin_news.article.permission_ids', permissionIds));
      }

      dispatch({type: 'GET_NEWS_ARTICLE_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_NEWS_ARTICLE_REJECTED', payLoad: error.data});
    });
};

export const deleteArticle = id => (dispatch) => {
  dispatch({type: 'DELETE_NEWS_ARTICLE_PENDING'});
  return irelandApi.delete(`/api/admin/articles/${id}`)
    .then(() => {
      toast.success(<ToastMessage
        iconStyle="success"
        message="News article has been deleted successfully"
      />);
      dispatch({type: 'DELETE_NEWS_ARTICLE_FULFILLED', payLoad: id});
    })
    .catch((error) => {
      toast.error(<ToastMessage
        iconStyle="error"
        message="An error occured during delete news article"
      />);
      dispatch({type: 'DELETE_NEWS_ARTICLE_REJECTED', payLoad: error.data});
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    });
};

const createGroupIdList = groups => ({
  group_ids: groups.map(group => +group.value)
});

const miniChainEligiblity = (payLoad) => {
  const { mc_only_outlets: mcOnlyOutlets, non_mc_only_outlets: nonMcOnlyOutlets } = payLoad;

  if (!mcOnlyOutlets && !nonMcOnlyOutlets) {
    return 'No Outlets';
  }

  if (mcOnlyOutlets && !nonMcOnlyOutlets) {
    return 'MC Only Outlets';
  }

  if (!mcOnlyOutlets && nonMcOnlyOutlets) {
    return 'Non MC Only Outlets';
  }

  return 'All Outlets';
};

const transformArticle = (payLoad) => {
  const tags = [];

  if (payLoad.tags) {
    if (payLoad.tags[0]) {
      tags.push('Incentives');
    }

    if (payLoad.tags[1]) {
      tags.push('Updates');
    }

    if (payLoad.tags[2]) {
      tags.push('Trade');
    }
  }

  const mPayLoad = {
    ...payLoad,
    mini_chain_eligibility: miniChainEligiblity(payLoad),
    tags: tags.join(','),
    linked_article_ids: payLoad.linked_article_ids.map(article => +article.value),
    group_ids: payLoad.group_ids.map(group => +group.value),
    abm_codes: payLoad.abm_codes ? payLoad.abm_codes.map(abmCode => abmCode.value) : [],
    permission_ids: [],
    ...createGroupIdList(payLoad.group_ids),
  };

  Object.keys(payLoad.permission_ids).forEach((key) => {
    if (payLoad.permission_ids[key].checked) {
      mPayLoad.permission_ids.push(+key);
    }
  });

  return mPayLoad;
};

const assembleFormData = (article) => {
  const formData = new FormData();
  Object.keys(article).forEach((key) => {
    if (article[key] instanceof Array) {
      article[key].forEach((item) => {
        formData.append(`article[${key}][]`, item);
      });
    } else if (article[key] !== null) {
      formData.append(`article[${key}]`, article[key]);
    }
  });

  return formData;
};

export const saveArticle = (payLoad) => {
  const article = transformArticle(payLoad);
  const formData = assembleFormData(article);

  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };
  return irelandApi.post('/api/admin/articles/', formData, config)
    .then(() => {
      toast.success(<ToastMessage
        iconStyle="success"
        message="News article has been saved successfully"
      />);
      history.push('/admin/news/articles');
    })
    .catch((error) => {
      toast.error(<ToastMessage
        iconStyle="error"
        message="An error occurred during save news article"
      />);
      store.dispatch(actions.resetValidity('deep.admin_news.article'));
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    });
};

export const updateArticle = (id, payLoad) => {
  const article = transformArticle(payLoad);
  const formData = assembleFormData(article);

  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };
  return irelandApi.put(`/api/admin/articles/${id}`, formData, config)
    .then(() => {
      toast.success(<ToastMessage
        iconStyle="success"
        message="News article has been saved successfully"
      />);
      history.push('/admin/news/articles');
    })
    .catch((error) => {
      toast.error(<ToastMessage
        iconStyle="error"
        message="An error occurred during save news article"
      />);
      store.dispatch(actions.resetValidity('deep.admin_news.article'));
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    });
};
